<ng-container *ngIf="!spinner && !passwordIsValid">
  <ion-item>
    <ion-input
      type="password"
      label="{{ 'PUZZLE.leaderboard_review.labels.password' | translate }}"
      [(ngModel)]="password"
      (keydown.enter)="submitPassword()">
      <!--ion-input-password-toggle slot="end"></ion-input-password-toggle-->
      <div *ngIf="errorMessage" slot="label">
        <ion-text color="danger">
          {{ errorMessage }}
        </ion-text>
      </div>
    </ion-input>

    <ion-button (click)="submitPassword()">
       {{ 'PUZZLE.leaderboard_review.buttons.login' | translate }}
    </ion-button>
  </ion-item>
</ng-container>

<ion-spinner *ngIf="spinner"></ion-spinner>
<ng-container *ngIf="!spinner && passwordIsValid === true">
  <ion-content>
  <ion-grid *ngIf="selectedCollectionEntries.length > 0">
  <ion-row>
    <ion-col>
      <ion-button
        [fill]="mode === 'ok' ? 'solid' : 'outline'"
        (click)="changeMode('ok');"
        size="small"
      >
        {{ "PUZZLE.leaderboard_review.buttons.tab_ok" | translate }}
      </ion-button>
    </ion-col>
    <ion-col>
      <ion-button
        [fill]="mode === 'profane' ? 'solid' : 'outline'"
        (click)="changeMode('profane');"
        size="small"
      >
        {{ "PUZZLE.leaderboard_review.buttons.tab_profane" | translate }}
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="2">
      <ion-button fill="clear"[disabled]="nextIsDisabled" (click)="loadNextCollection();">
        <ion-icon slot="icon-only" name="arrow-back-outline"/>
      </ion-button>
    </ion-col>
    <ion-col size="8">
      <ion-select label="{{ 'PUZZLE.leaderboard_review.labels.choice' | translate }}" [ngModel]="selectedCollectionId" (ionChange)="selectCollection($event)">
        <ion-select-option *ngFor="let collection of leaderboardCollections$ | async; index as i" value="{{ collection.id }}">
          {{ 'PUZZLE.leaderboard_review.item.' + (collection.strictRules && "strict" || "relaxed") | translate: collection }}
        </ion-select-option>
      </ion-select>
    </ion-col>
    <ion-col size="2">
      <ion-button fill="clear" [disabled]="backIsDisabled" (click)="loadPreviousCollection();">
        <ion-icon slot="icon-only" name="arrow-forward-outline"/>
      </ion-button>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col>
      <table>
        <tr>
          <th class="lb-placement">
            {{ 'PUZZLE.leaderboard_review.table_title.rank' | translate }}
          </th>
          <th class=lb-name>
            {{ 'PUZZLE.leaderboard_review.table_title.name' | translate }}
          </th>
          <th class=lb-time>
            {{ 'PUZZLE.leaderboard.table_title_time' | translate }}
          </th>
          <th class=lb-checks>
            {{ 'PUZZLE.leaderboard_review.table_title.checks' | translate }}
          </th>
          <th class=lb-select>
            {{ 'PUZZLE.leaderboard_review.table_title.action' | translate }}
          </th>
        </tr>
        <tr
          class=lb-top
          *ngFor="let entry of selectedCollectionEntries; index as i"
        >
          <ng-container *ngIf="(mode === 'ok' && !entry.profanity) || (mode === 'profane' && entry.profanity)">
            <td class="lb-placement">
              {{ entry.rank }}.
            </td>
            <td class=lb-name>
              {{ entry.nickname }}
            </td>
            <td class=lb-time>
              {{ entry.timePlayed | timeFromMS }}
            </td>
            <td class=lb-checks>
              <span *ngFor="let check of (entry.profanityChecks || [])" slot="end">
                {{ "PUZZLE.leaderboard_review.check." + check | translate}}&nbsp;
              </span>
            </td>
            <td class=lb-select>
              <ion-checkbox
                  slot="end"
                  color="bic"
                  [ngModel]="changedCollectionEntries[mode][entry.id]"
                  (ionChange)="mark(entry, mode)"
              />
            </td>
          </ng-container>
        </tr>
      </table>
      <p *ngIf="selectedCollectionEntries.length === 0">
        {{ "PUZZLE.leaderboard.message_empty" | translate }}
      </p>
    </ion-col>
  </ion-row>
</ion-grid>
</ion-content>
<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col size="3">
        <ion-button
          fill="outline"
          size="small"
          (click)="deselectAll(mode);"
        >
          {{ "PUZZLE.leaderboard_review.buttons.deselect_all" | translate }}
        </ion-button>
      </ion-col>
      <ion-col size="3">
        <ion-button
          fill="outline"
          size="small"
          (click)="selectAll(mode);"
        >
          {{ "PUZZLE.leaderboard_review.buttons.select_all" | translate }}
        </ion-button>
      </ion-col>
      <ion-col size="1">
      </ion-col>
      <ion-col size="5">
        <td class="button">
          <ion-button *ngIf="mode==='ok'" (click)="markAll(mode);" size="small">
            {{ 'PUZZLE.leaderboard_review.buttons.mark_profanity' | translate }}
          </ion-button>
          <ion-button *ngIf="mode==='profane'" (click)="markAll(mode);" size="small">
            {{ 'PUZZLE.leaderboard_review.buttons.mark_ok' | translate }}
          </ion-button>
        </td>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
</ng-container>
